import FormGroupBox from '~/jobiqo/components/Form/Widgets/Form/FormGroupBox';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import ScreeningQuestions from '../components/ScreeningQuestions';
import * as Yup from 'yup';
import { CommonTranslationsType } from '~/jobiqo/utils/intl';

/**
 * Overrides the default job form.
 *
 * Includes new fields for the form when the job application is set to Quick apply.
 */
export function getJobQuickApplyOverrides() {
  return {
    field_job_app_questions: ({ field, values }) => {
      const applicationWorkflow = values.field_job_application_workflow;
      const isInternal =
        applicationWorkflow === 'internal' || applicationWorkflow === 'quick';
      return (
        <div key={field.id}>
          <Spacing size="medium" />
          <ScreeningQuestions
            entityField={field}
            hasQuestions={isInternal && values?.field_job_app_require_questions}
          />
          <Spacing size="medium" />
        </div>
      );
    },
  };
}

export function quickApplyGroupOverrides() {
  return {
    job_quick_apply: ({
      group,
      values,
      isValid,
      bundle,
      overrides,
      formGroupsChildren,
      name,
    }) => (
      <FormGroupBox
        group={group}
        isValid={isValid}
        bundle={bundle}
        overrides={overrides}
        formGroupsChildren={formGroupsChildren}
        name={name}
      />
    ),
  };
}

export function getJobFormQuickApplyValidationSchema({
  FIELD_REQUIRED,
}: CommonTranslationsType) {
  return {
    field_job_app_questions: Yup.array().of(
      Yup.object().shape({
        question: Yup.string().nullable().required(FIELD_REQUIRED),
        required: Yup.boolean(),
      }),
    ),
  };
}
